import { APIManager } from "shared/manager";
import { RestEnds } from "../shared/Constants";
import AxiosManager from "shared/manager/AxiosManager";

const loginBroker = async (data) => {
  return APIManager.sendPost(
    `${RestEnds.BROKER}/login`,
    AxiosManager,
    data,
    false,
    {},
    {}
  );
};

const changePassword = async (data) => {
  return APIManager.sendPatch(
    `${RestEnds.BROKER}/change-password`,
    AxiosManager,
    data,
    true,
    {},
    {}
  );
};

const getBrokerDetails = async () => {
  return APIManager.sendGet(
    `${RestEnds.BROKER}/profile-details`,
    AxiosManager,
    true,
    {},
    {}
  );
};

const getAllApplcations = async (offset, limit, brokerId) => {
  return APIManager.sendGet(
    `${RestEnds.BROKER}/applications?offset=${offset}&limit=${limit}&brokerId=${brokerId}`,
    AxiosManager,
    true,
    {},
    {}
  );
};

const createApplication = async (data) => {
  return APIManager.sendPost(
    `${RestEnds.BROKER}/applicant-loan`,
    AxiosManager,
    data,
    true,
    {},
    {}
  );
};

export const BrokersService = {
  loginBroker,
  changePassword,
  getBrokerDetails,
  getAllApplcations,
  createApplication,
};
